import styled from '@emotion/styled';

const Token = styled('span')((p) => ({
  backgroundColor: p.theme.custom.colors.gray.w200,
  color: p.theme.custom.colors.gray.w600,
  borderRadius: p.theme.custom.border.radius(2),
  padding: `${p.theme.spacing(0.5)}px ${p.theme.spacing(1.25)}px`,
  marginLeft: p.theme.spacing(0.25),
  marginRight: p.theme.spacing(0.25)
}));

export const WithTokenPill = ({ d }: { d?: string | null }) => {
  // Function to parse handlebar syntax and render tokens
  const renderWithTokens = (text: string) => {
    // Split the text by handlebar patterns
    const parts = text.split(/(\{\{[^}]+\}\})/);

    return parts.map((part, index) => {
      // Check if this part is a handlebar token
      const tokenMatch = part.match(/^\{\{([^}]+)\}\}$/);

      if (tokenMatch) {
        // This is a token, render it in a span
        return <Token key={index}>{tokenMatch[1].trim()}</Token>;
      } else {
        // This is regular text, render as-is
        return part;
      }
    });
  };

  return <div>{renderWithTokens(d || '')}</div>;
};
